import { render, staticRenderFns } from "./InfoForm.vue?vue&type=template&id=ad2bd518&scoped=true&"
import script from "./InfoForm.vue?vue&type=script&lang=js&"
export * from "./InfoForm.vue?vue&type=script&lang=js&"
import style0 from "./InfoForm.vue?vue&type=style&index=0&id=ad2bd518&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad2bd518",
  null
  
)

export default component.exports